export function scrollLogo() {
  const logo = document.querySelector('.js-home-header-logo');
  if(logo) {
    const SCROLL = function() {
      const scTop = (document.documentElement && document.documentElement.scrollTop) || document.body.scrollTop;
      if(scTop >= 150) {
        logo.classList.add('is-visible');
        logo.classList.remove('is-hidden-transition');
      } else {
        logo.classList.remove('is-visible');
        logo.classList.add('is-hidden-transition');
        setTimeout(() => {
          logo.classList.remove('is-hidden-transition');
        }, 600);
      }
    }

    window.addEventListener('resize', SCROLL);
    window.addEventListener('orientationchange', SCROLL);
    window.addEventListener('scroll', SCROLL);
    SCROLL();
  }
}